export const REEM_USER_STORAGE = 'reem-user';
export const REEM_DEVICE_STORAGE = 'reem-device';
export const REEM_DEVICE_ID = 'WEB_REEM_AUTH';
